import { register } from 'register-service-worker'

import store from '@/store'

if (process.env.NODE_ENV === 'production') {
  register('/service-worker.js', {
    updated(reg) {
      store.commit(`app/setSWRegistrationForNewContent`, reg)
    },
    error() {
      store.commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'error',
          message: 'Error during service worker registration'
        },
        { root: true }
      )
    }
  })
}

if ('serviceWorker' in navigator) {
  let refreshing = false
  // This is triggered when a new service worker take over
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return
    refreshing = true

    window.location.reload()
  })
}
